// The viewer's app user id, for sender comparisons in the transcript. Hosts
// resolve it (V3 modules cannot import the app-wide data-fetching barrel) and
// pass it through V3RunSurface; null until it loads or outside a harness, so
// a primitive mounted alone (the admin gallery, tests) keeps the unattributed
// default.
import { createContext, useContext } from 'react';

export const ViewerUserIdContext = createContext<string | null>(null);

export function useViewerUserId(): string | null {
    return useContext(ViewerUserIdContext);
}
